import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";
export const prodFile= "https://erp-hhs.vastedge.com/api"

export function getFileCabinet(token, query) {
  const q = buildQuery(query);
  return axios.get(`${prodFile}/getFileCabinet${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getFilesInFolder(token, query) {
  const q = buildQuery(query);
  return axios.get(`${prodFile}/getFilesInFolder${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getDownloadDocument(token, options, query) {
  const q = buildQuery(query);
  return axios.get(
    `${prodFile}/downloadFile${q}`,
    options
    //    {
    //     headers: {
    //       authorization: token,
    //     },
    // responseType: "blob",
    //   }
  );
}
export function getFilteredFile(token, query) {
  const q = buildQuery(query);
  return axios.get(`${prodFile}/getFilteredFiles${q}`, {
    headers: {
      authorization: token,
    },
  });
}